import React from 'react';

import CommonCheckbox from '../../../components/common-checkbox/CommonCheckbox';

import scss from './ColumnFilter.module.scss';

function FilterListItem({ option, selectedOptions, onSelect }) {
  const { subheader, id } = option;

  const isSelected = selectedOptions?.some(({ id: optionId }) => optionId === id);

  const handleSelect = () => {
    onSelect(option);
  };

  return (
    <li className={scss['filter-item']} onClick={handleSelect} role='presentation'>
      <CommonCheckbox checked={isSelected} readonly />
      <span className={scss['filter-item_label']}>{subheader}</span>
    </li>
  );
}

export default FilterListItem;
